module.exports = __webpack_public_path__ + "img/kira.cbdcd051.webp";